'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = QueryGreaterThan;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Query = require('../Query');

var _Query2 = _interopRequireDefault(_Query);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
* The QueryGreaterThan checks that the value in the number field is greater than
* the value passed.
*/


function QueryGreaterThan(props) {
  return _react2.default.createElement(_Query2.default, _extends({}, props, {
    predicate: 'gt'
  }));
}

QueryGreaterThan.propTypes = {
  /** Defines what the query will be looking for. The only path available is
   * 'my.{custom-type}.{field}', where {custom-type} is the API ID of the custom
   * type you want to query and {field} is the API ID of the specific field in
   * the custom type that you need. */
  path: _propTypes2.default.string.isRequired,

  /** Defines the value that the query is looking for. Accept single number value. */
  value: _propTypes2.default.number,

  /** The componet used to render the queried data. */
  component: _propTypes2.default.func,

  /** It will remove all the documents except for those after the specified document in the list.
   * By reversing the orderings in your query, you can use this same method to retrieve all
   * the documents before the specified document. */
  after: _propTypes2.default.string,

  /** It is used to make queries faster by only retrieving the specified field(s). */
  fetch: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /** It allows you to retrieve a specific content field from a linked document and
   * add it to the document response object.
   * This props needs to take the following format:
   * '{custom-type}.{field}' or ['{custom-type}.{field}', '{other-custom-type}.{field}'] */
  fetchLinks: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /** It will order the results by the specified field(s).
   * You can specify as many fields as you want.
   * It will automatically order the field from lowest to highest e.g('[my.product.price]').
   * Use "desc" next to the field name to instead order it from greatest
   * to lowest e.g('[my.product.price desc]').
   * You can specify more than one field to order your results by. To do so,
   * simply add more than one field in the array e.g('[my.product.price, my.product.title]').
   * It is also possible to order documents by their first or
   * last publication dates e.g('[document.first_publication_date]'). */
  orderings: _propTypes2.default.string,

  /** The page option defines the pagination for the result of your query.
   * This value defaults to "1", corresponding to the first page. */
  page: _propTypes2.default.number,

  /** The pageSize option defines the maximum number of documents that the API
   * will return for your query. This value defaults to 20, max is 100. */
  pageSize: _propTypes2.default.number
};
QueryGreaterThan.defaultProps = {
  value: 0,
  component: undefined,
  after: undefined,
  fetch: undefined,
  fetchLinks: undefined,
  orderings: undefined,
  page: 1,
  pageSize: 20
};